import styled from 'styled-components';

export const Wrapper = styled.footer`
  color: var(--color-text-light);
  width: 100%;
  background: var(--color-primary);
  padding-bottom: 1.5rem;
  position: relative;
  bottom: 0;
  z-index: 1;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding-top: 6.5rem;
  }

  @media (${({ theme }) => theme.respondTo.desktopL}) {
    padding: 6.5rem 0 8rem;
  }
`;
